(function (angular) {
    'use strict';

    angular.module('twitter')

        /**
         *
         */
        .factory('twitterServices',
            ['$http', '$q', 'portalConfig',
                function ($http, $q, portalConfig) {

                    var urlBase = portalConfig.urlBase;
                    //urlBase = "http://localhost:8002";
                    var fac = {
                        getTwitterDetails: getTwitterDetails,
                        setTwitterDetails: setTwitterDetails,
                        deleteTwitterDetails: deleteTwitterDetails
                    };

                    return fac;

                    function getTwitterDetails(apiSpaceId) {
                        return $http.get(urlBase + "/apispaces/" + apiSpaceId + "/channels/twitter").then(function (response) {

                            return response.data;
                        }).catch(function (error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        });
                    }

                    function setTwitterDetails(apiSpaceId, data) {
                        return $http.put(urlBase + "/apispaces/" + apiSpaceId + "/channels/twitter", data).then(function (response) {
                            return response.data;
                        }).catch(function (error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        });
                    }

                    function deleteTwitterDetails(apiSpaceId) {
                        return $http.delete(urlBase + "/apispaces/" + apiSpaceId + "/channels/twitter").then(function (response) {
                            return response.data;
                        }).catch(function (error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        });
                    }
                }]);

})(window.angular);
